export enum ObservedAdverseEffectLevel {
  NOAEL = 'NOAEL',

  LOEL = 'LOEL',

  UNOEL = 'UNOEL',
}
